(function () {
    'use strict';
    angular.module('Directives').directive('bbaMapV2', bbaMapV2);
    bbaMapV2.$inject = [];
    function bbaMapV2() {
        return {
            restrict: 'E',
            scope: {
                mapCenter: '='
            },
            template: '<div class="map_v2" id="map-v2"></div>',
            link: bbaMapV2Link
        }

        function bbaMapV2Link(scope, element, attrs) {
            const mapOptions = {
                zoom: 21,
                center: new google.maps.LatLng(scope.mapCenter.lat, scope.mapCenter.lng),
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                }
            };

            init();

            function init() {
                const map = new google.maps.Map(document.getElementById('map-v2'), mapOptions);
                new google.maps.Marker({
                    position: mapOptions.center,
                    map: map,
                    title: 'Delivery Location'
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/maps/bbaMapV2.js